import { instance } from 'store/utils';
import { types } from './types';
import { downloadFile, downloadRequestHeaders } from 'store/forms/utils';
import { message } from 'antd';
import { triggerLoading } from 'store/forms/actions';

export const react_path = process.env.REACT_APP_PROCESS_APP;

export const fetchProcessSAYT = searchKey => dispatch => {
  dispatch({ type: types.FETCH_PROCESS_SAYT.START });
  instance
    .get(`/app/rest/findSAYT?searchKey=` + searchKey)
    .then(response => {
      dispatch({
        type: types.FETCH_PROCESS_SAYT.SUCCESS,
        payload: response.data,
      });
    })
    .catch(error => {
      console.log(error, 'error');
      dispatch({ type: types.FETCH_PROCESS_SAYT.ERROR });
    });
};

export const getActions = procInstId => dispatch => {
  dispatch({ type: types.GET_ACTIONS.START });
  instance
    .get(`/app/rest/${procInstId}/actions`)
    .then(response => {
      dispatch({ type: types.GET_ACTIONS.SUCCESS, payload: response.data });
    })
    .catch(error => {
      console.log(error, 'error');
      dispatch({ type: types.GET_ACTIONS.ERROR });
    });
};

export const getTaskData = taskId => dispatch => {
  dispatch({ type: types.GET_TASK_DATA.START });
  instance
    .get(`/app/rest/tasks/${taskId}`)
    .then(response => {
      dispatch({ type: types.GET_TASK_DATA.SUCCESS, payload: response.data });
    })
    .catch(error => {
      console.log(error, 'error');
      dispatch({ type: types.GET_TASK_DATA.ERROR });
    });
};

export const fetchProcInstancesFundingPaginated =
  (detailedPayload, page, pageSize) => dispatch => {
    dispatch(triggerLoading(true));
    let payload = {
      parameterList: detailedPayload?.parameterList ?? [],
      page,
      pageSize,
    };
    dispatch({ type: types.GET_FUNDING_ADMIN_APPTRACK.START });
    instance
      .post(`/onboarding/funding-admin/interest-application/search`, payload)
      .then(response => {
        const res = response.data.data;
        const resultSize = response?.data?.size;
        const results = Object.entries(res).map(([key, value]) => ({
          id: key,
          ...value,
        }));

        results.sort((a, b) => Number(a.id) - Number(b.id));

        dispatch({
          type: types.GET_FUNDING_ADMIN_APPTRACK.SUCCESS,
          payload: {
            variables: results,
            resultSize: resultSize,
          },
        });
        dispatch(triggerLoading(false));
      })
      .catch(error => {
        console.log(error, 'error');
        dispatch({ type: types.GET_FUNDING_ADMIN_APPTRACK.ERROR });
        dispatch(triggerLoading(false));
      });
  };

// GET /onboarding/funding-admin/interest-application/16
export const getInterestApplication = id => dispatch => {
  dispatch(triggerLoading(true));
  dispatch({ type: types.GET_INTEREST_APPLICATION.START });
  instance
    .get(`/onboarding/funding-admin/interest-application/${id}`)
    .then(response => {
      const res = response.data;
      dispatch(triggerLoading(false));

      dispatch({
        type: types.GET_INTEREST_APPLICATION.SUCCESS,
        payload: res,
      });
    })
    .catch(error => {
      dispatch(triggerLoading(false));
      console.log(error, 'error');
      dispatch({ type: types.GET_INTEREST_APPLICATION.ERROR });
    });
};

// POST /onboarding/funding-admin/interest-application/{id}/review
export const reviewInterestApplication = (params, callback) => dispatch => {
  const payload = !params.accept
    ? {
        accept: params.accept,
        comment: params.comment,
      }
    : {
        accept: params.accept,
      };

  dispatch(triggerLoading(true));
  dispatch({ type: types.REVIEW_INTEREST_APPLICATION.START });
  instance
    .post(
      `/onboarding/funding-admin/interest-application/${params.id}/review`,
      payload
    )
    .then(response => {
      const res = response.data;
      console.log('ressss:', res);
      dispatch(triggerLoading(false));
      callback(false);
    })
    .catch(error => {
      dispatch({
        type: types.REVIEW_INTEREST_APPLICATION.ERROR,
        payload: error.response.data,
      });
      callback(true);
      dispatch(triggerLoading(false));
    });
};

export const clearApptrack = () => dispatch => {
  dispatch({ type: types.CLEAR_APPTRACK.SUCCESS });
};

export const clearSayt = () => dispatch => {
  dispatch({ type: types.CLEAR_SAYT });
};

export const clearForm = payload => dispatch => {
  dispatch({ type: types.CLEAR_FORM.SUCCESS, payload });
};
